import React, { Component } from 'react';
import classNames from 'classnames';
import { ReactComponent as DropdownIcon } from 'Icons/downArrow.svg';
import OutsideClickHandler from 'react-outside-click-handler';
import ClickOutside from 'Components/ClickOutside/index';
// import { convertToPascalCase } from 'Utils/';

class MultipleDropdown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isDropdownShown: false,
            searchText: "",
            inputValue: props.selectedItems || []
        }
    }
    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (this.state.inputValue !== nextProps.inputValue) {
            this.setState({
                inputValue: nextProps.selectedItems || []
            })
        }
    }
    showDropdown = (e) => {
        const { items } = this.props;
        if (e) {
            e.stopPropagation();
        }
        if (items && items.length) {
            this.setState({
                isDropdownShown: true
            });
        }
    }

    hideDropdown = () => {
        this.setState({
            isDropdownShown: false,
            searchText: ''
        });
    }

    onSelect = (item, e) => {
        if (e) { e.stopPropagation() }
        const { onSelect, name } = this.props;
        onSelect(item, name);
        this.hideDropdown();
    }
    onClearFilter = (e) => {
        if (e) { e.stopPropagation() }
        const { onSelect, name } = this.props;
        console.log(e);
        onSelect({}, name);
        this.hideDropdown();
    }
    onDeselect = (item, e) => {
        if (e) { e.stopPropagation() }

        this.props.deselect(item);
        this.hideDropdown();

    }
    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    onInputChange = (e) => {
        this.setState({
            inputValue: [...this.state.inputValue, e.target.value]
        });
    }
    onInputBlur = () => {
        const { onSelect, name, displayKey, selectedItems } = this.props;
        if ((selectedItems !== this.state.inputValue) || !selectedItems) {
            this.state.inputValue.map((value) => {

                onSelect({
                    [displayKey]: value
                }, name)
            })
        }
    }
    render() {
        const {
            label,
            items,
            className,
            selectedItems,
            displayKey,
            noBorder,
            searchPlaceholder,
            searchEnabled,
            hasError,
            errorText,
            isMinHeight,
            isInput
        } = this.props;
        return (
            <ClickOutside handleClickOutside={this.hideDropdown}>
                <div className={"pr dropdown-container pr " + className}>
                    <div onClick={this.showDropdown} className={classNames("flex flex-middle flex-between br-5", {
                        'border-theme': !noBorder,
                        'min-ht-40': isMinHeight,
                        'ht-40': !isMinHeight
                    })}
                    >
                        {
                            items && items.length > 0 &&
                            <div className="mr-10 flex flex-column">
                                {
                                    (selectedItems || []).map(item => {
                                        return (
                                            <>
                                                <div className={'mr-5 ml-5 theme-color curP fBold'} onClick={this.onDeselect.bind(this, item)}>{item[displayKey]} X</div>
                                            </>
                                        )
                                    })
                                }
                            </div>
                        }
                        <div
                            className={"flex-1 curP flex flex-middle pl-5 pr-5 label-color fSemibold"}>

                            <input className="col-1 fSemibold" disabled={!isInput} onChange={this.onInputChange} onBlur={this.onInputBlur} placeholder={!((selectedItems || []).length) ? label : ''} />

                            < DropdownIcon />
                        </div>


                    </div>
                    {/* {hasError && !this.state.isDropdownShown && <div className="error-color fs-14 fSemibold op-7 mt-10 ml-5">{errorText && convertToPascalCase(errorText) || 'Please Select The Field'}</div>} */}
                    {this.state.isDropdownShown &&
                        <div className={classNames("box-shadow bg-white br-5 z-1 pa col-1", {
                            't-100p': !noBorder,
                            't40': noBorder
                        })}>
                            {searchEnabled && <div className="mr-15 ml-15 mt-10 mb-5">
                                <input placeholder={searchPlaceholder || "Search items"}
                                    type="text"
                                    className=" col-1 br-20 ht-40 bg-gray search"
                                    name="searchText"
                                    onChange={this.onChange}
                                />
                            </div>}
                            <div className={'max-height-400 overflowAuto'}>
                                {
                                    items.filter((item) => {
                                        const { searchText } = this.state;
                                        if (!searchText) {
                                            return true;
                                        }
                                        return item[displayKey].toLowerCase().includes(searchText.toLowerCase());
                                    }).map((item, index) => {
                                        return (
                                            <div
                                                key={index}
                                                name={item.name}
                                                className={"flex flex-middle pl-10 min-ht40 fs-16 label-color bg-hover-theme pt-5 pb-5"}
                                                onClick={this.onSelect.bind(this, item)}
                                            >
                                                {item[displayKey]}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>}
                </div>
            </ClickOutside>
        );
    }
}

export default MultipleDropdown;